import { render, staticRenderFns } from "./DecentralizationTransaction.vue?vue&type=template&id=99db6f54&scoped=true&"
import script from "./DecentralizationTransaction.vue?vue&type=script&lang=js&"
export * from "./DecentralizationTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99db6f54",
  null
  
)

export default component.exports